import React,{useState,useEffect} from 'react';

import { FaBars } from 'react-icons/fa';
import { Nav,
    NavbarContainer,
    NavLogo,
    MobileIcon,
    NavMenu,
    NavItem,
    NavLinks,
    NavBtn,
    NavBtnLink, 
    NavLinksAbout} from './Navbar2Elements';

import Logo from '../../images/imageedit_13_5201923858.png'
import SaiLogo from '../../images/SaiLogo.png'
import UserBar from '../UserBar';

const Navbar = (props) => {
    const [scrollNav,setSrollNav]= useState(false);
    const user = 'Amal'
    const changeNav = ()=>{
        if(window.scrollY >= 180){
            setSrollNav(true)
        }else{
            setSrollNav(false)
        }
    };
    useEffect(()=>{
        window.addEventListener('scroll',changeNav);
    },[])

    return (
        <>
            {/* <Nav scrollNav={scrollNav} >
               <NavbarContainer>
                   <NavLogo to='/'><img style={{height: '100px',width:'150px',paddingBottom:'6px'
                   
                   }} src={SaiLogo} alt='logo'></img></NavLogo>
                   <MobileIcon onClick={props.toggle}>
                       <FaBars />
                   </MobileIcon>
                   <NavMenu>
                       <NavItem>
                           <NavLinks    to='/#home'>Home</NavLinks>
                       </NavItem>
                       
                       <NavItem>
                            
                           <NavLinks  to='/amenities'>Amenities</NavLinks>
                       </NavItem>

                       <NavItem>
                           <NavLinks   to='/gallery'>Gallery</NavLinks>
                       </NavItem>
                       
                       <NavItem>
                            
                           <NavLinks  to='/discover'>Rooms and Suites</NavLinks>
                       </NavItem>
                       <NavItem>
                           <NavLinks  to='/signup'>Sign-Up</NavLinks>
                       </NavItem>
                       {
                           user?<NavBtn>
                           <NavBtnLink to="">Sign-Out</NavBtnLink>
                       </NavBtn>:<NavBtn>
                           <NavBtnLink to="/signin">Sign-In</NavBtnLink>
                       </NavBtn>
                       }
                       {
                           user?<UserBar elm={user} />: null
                       }
                       
                   </NavMenu>
               </NavbarContainer>
            </Nav> */}
        </>   
        
    )
}

export default Navbar
